import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class DomainService {
  private readonly domain: string;
  private readonly title: string;

  get pageTitle() {
    return this.title;
  }

  get wlAssetURL() {
    return `${environment.s3URL}/${environment.assetPath}/${this.domain}`;
  }

  get commonAssetURL() {
    return `${environment.s3URL}/${environment.assetPath}/common`;
  }

  constructor() {
    // "dev-desktop.wincash100.com"
    const hostname = window.location.hostname;
    this.domain = this.extractRootDomain(hostname === "localhost" ? "dev-desktop.freedemokit.com" : hostname);
    this.title = this.extractTitle(hostname);
    console.log("Hostname", hostname);
    console.log("Domain", this.domain);
    console.log("Title", this.title);
  }

  private extractRootDomain(hostname: string): string {
    const parts = hostname.split(".");
    if (parts.length > 1) {
      return parts.slice(1).join(".");
    }
    return hostname;
  }

  private extractTitle(hostname: string): string {
    const parts = hostname.split(".");
    let title = parts.length > 2 ? parts[parts.length - 2] : parts[0];

    // Capitalize the first letter
    return title.charAt(0).toUpperCase() + title.slice(1);
  }

  getDomain(): string {
    return this.domain;
  }

  get demoCredentials() {
    const modifiedDomain = this.domain.replace(".", "");
    const credential = `demo-${modifiedDomain}`;
    return {
      username: credential,
      password: credential,
    };
  }
}
